import { Injectable } from '@angular/core';
import { AuthRole } from '../enums/auth-role';
import { AuthPolicy } from '../enums/auth-policy';

@Injectable({
  providedIn: 'root'
})
export class PolicyService {

  constructor() { }

  getPolicy(authPolicy: AuthPolicy, authRoles: string[]): boolean {
    switch (authPolicy) {
      case AuthPolicy.User:
        return authRoles.some((r) => r === AuthRole.User || r === AuthRole.PT || r === AuthRole.PTAdmin || r === AuthRole.Developer)

      case AuthPolicy.PT:
        return authRoles.some((r) => r === AuthRole.PT || r === AuthRole.PTAdmin || r === AuthRole.Developer)

      case AuthPolicy.PTAdmin:
        return authRoles.some((r) => r === AuthRole.PTAdmin || r === AuthRole.Developer)

      case AuthPolicy.Developer:
        return authRoles.some((r) => r === AuthRole.Developer)

      default:
        return false;
    }
  }
}
